<template>
  <div class="main-container">
    <acca-vue-notification message="Link kopyalandı!" v-if="isCodeCopied"></acca-vue-notification>

    <div class="document-actions-container col-start-1 col-end-13 mt-10">
      <docuement-filter-widget @searchOccured="searchList" :searchTerm="searchTerm"></docuement-filter-widget>
      
    
      
      <document-view-switcher 
        :selectedView="selectedComponent" 
        @viewSet="displaySelectedComponent" 
        class="col-start-12 col-end-12"
      ></document-view-switcher>
    </div>

    <div v-if="loading" class="col-span-full flex justify-center items-center py-20">
      <p class="text-2xl text-gray-500">Yükleniyor...</p>
    </div>

    <div v-else-if="filteredDocuments.length === 0" class="col-span-full flex justify-center items-center py-20">
      <p class="text-2xl text-gray-500">Bu klasörde doküman bulunamadı.</p>
    </div>

    <transition
      v-else
      appear
      type="animation"
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated animate__fadeOut animate__faster"
      mode="out-in"
    >
      <component 
        @codeCopied="showCopyNotification" 
        class="col-span-full" 
        :is="selectedComponent" 
        :documentData="filteredDocuments" 
        coverType="vertical"
      />
    </transition>
  </div>
</template>

<script>
import firebase from "../../firebase"
import DocumentTableView from "../reusable/DocumentTableView.vue"
import DocumentGridView from "../reusable/DocumentGridView.vue"
import DocumentViewSwitcher from "../reusable/DocumentViewSwitcher.vue"
import accaVueNotification from "../reusable/accaVueNotification.vue"
import DocuementFilterWidget from "../reusable/DocumentFilter.vue"
import PreparedFilter from "../reusable/PreparedFilter.vue"

export default {
  name: 'NewDocumentsFolder',

  data() {
    return {
      selectedComponent: "DocumentTableView",
      isCodeCopied: false,
      documents: [],
      loading: true,
      searchTerm: "",
      isListFiltered: false,
      filterTerm: "",
      company: "",
      subfolder: "",
      presetFilters: [
        {
          text: "Fiyat Listesi",
          searchTerm: "Fiyat Listesi",
          active: false,
        },
        {
          text: "Kataloglar",
          searchTerm: "Katalog",
          active: false,
        },
        { text: "Autocad", searchTerm: "DWG", active: false },
      ],
    }
  },

  computed: {
    filteredDocuments() {
      if (this.searchTerm === "" && this.filterTerm !== "") {
        return this.documents.filter(
          (document) => document.fileType.toLowerCase() === this.filterTerm
        )
      } else if (this.searchTerm !== "" && this.filterTerm === "") {
        return this.documents.filter(
          (document) =>
            document.title.toLowerCase().indexOf(this.searchTerm) > -1
        )
      } else if (this.searchTerm !== "" && this.filterTerm !== "") {
        const filteredList = this.documents.filter(
          (document) => document.fileType.toLowerCase() === this.filterTerm
        )
        return filteredList.filter(
          (document) =>
            document.title.toLowerCase().indexOf(this.searchTerm) > -1
        )
      } else {
        return this.documents
      }
    },
  },

  methods: {
    displaySelectedComponent(view) {
      this.selectedComponent = view
    },

    filterList(filterTerm, index) {
      if (!this.isListFiltered) {
        this.filterTerm = filterTerm.toLowerCase()
        this.isListFiltered = true
        this.presetFilters.forEach((filterItem, i) => {
          if (i === index) {
            filterItem["active"] = true
          }
        })
      } else {
        const activeElementIndex = this.presetFilters.findIndex(
          (item) => item.active === true
        )

        if (activeElementIndex === index) {
          this.filterTerm = ""
          this.isListFiltered = false
          this.presetFilters.forEach((filterItem) => {
            filterItem["active"] = false
          })
        } else {
          this.filterTerm = filterTerm.toLowerCase()
          this.isListFiltered = true
          this.presetFilters.forEach((filterItem, i) => {
            if (i === index) {
              filterItem["active"] = true
            } else {
              filterItem["active"] = false
            }
          })
        }
      }
    },

    showCopyNotification() {
      this.isCodeCopied = true
      setTimeout(() => {
        this.isCodeCopied = false
      }, 2000)
    },

    async getData() {
      this.loading = true
      this.company = this.$route.query.company || ""
      this.subfolder = this.$route.query.subfolder || ""

      if (!this.company || !this.subfolder) {
        this.loading = false
        return
      }

      try {
        const db = firebase.firestore().collection("newDocs")
        const querySnapshot = await db
          .where("company", "==", this.company)
          .where("subfolder", "==", this.subfolder)
          .get()

        this.documents = []
        
        querySnapshot.forEach((doc) => {
          this.documents.push({
            id: doc.id,
            image: doc.data().image,
            title: doc.data().title,
            lang: doc.data().lang || "tr",
            fileType: doc.data().fileType,
            url: doc.data().url,
            year: doc.data().year || "-"
          })
        })
      } catch (error) {
        console.error("Error fetching documents:", error)
      } finally {
        this.loading = false
      }
    },

    searchList(searchTerm) {
      this.searchTerm = searchTerm.toLowerCase()
    }
  },

  components: {
    DocumentTableView,
    DocumentGridView,
    DocumentViewSwitcher,
    accaVueNotification,
    DocuementFilterWidget,
    PreparedFilter,
  },

  mounted() {
    this.getData()
  },

  watch: {
    '$route.query': {
      handler() {
        this.getData()
      },
      deep: true
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../styles/core/variables.scss";
  @import "../../styles/global/tables.scss";
</style>

